import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import BiskoTracker from './BiskoTracker'; 
import './App.css';

const Home = lazy(() => import('./components/Home/Home'));

function Loader() {
  return <div className="loading"></div>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* <BiskoTracker /> */}
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
